var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function Header(_a) {
    var title = _a.title, subtitle = _a.subtitle;
    return (_jsxs("div", __assign({ className: "flex flex-col items-start gap-2" }, { children: [_jsx("h1", __assign({ className: "text-base md:text-3xl font-semibold text-[#022A59]" }, { children: title })), subtitle && (_jsx("p", __assign({ className: "text-base md:text-xl font-semibold text-[#404040]" }, { children: subtitle }))), _jsx("hr", { className: "w-full border border-[#7F7D7D]" })] })));
}
